export default __webpack_public_path__ + "static/media/project1.1922d747.png";